import { render, staticRenderFns } from "./tab-history.vue?vue&type=template&id=533bd2ae&"
import script from "./tab-history.vue?vue&type=script&lang=js&"
export * from "./tab-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports